import type { IconData } from '@stacksjs/iconify-core'

export const sdCardSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M17.457 2.959c1.3-.986 2.883-1.462 4.492-1.459c1.042.002 1.902.01 2.044.011h.037c5.916 0 10.391.127 13.451.258a5.957 5.957 0 0 1 5.739 5.753c.14 3.445.28 8.804.28 16.483c0 7.748-.142 13.133-.284 16.574c-.128 3.107-2.533 5.543-5.645 5.676c-2.958.127-7.372.245-13.563.245s-10.605-.118-13.563-.245c-3.112-.133-5.517-2.569-5.645-5.676c-.141-3.441-.284-8.826-.284-16.573c0-1.14-.004-2.09-.009-2.964c-.003-.703-.007-1.356-.007-2.017c0-1.655.498-3.289 1.502-4.626c4.146-5.523 8.889-9.493 11.455-11.44M36.5 9a1.5 1.5 0 0 0-3 0v5a1.5 1.5 0 0 0 3 0zM29 7.5A1.5 1.5 0 0 1 30.5 9v5a1.5 1.5 0 0 1-3 0V9A1.5 1.5 0 0 1 29 7.5M24.5 9a1.5 1.5 0 0 0-3 0v5a1.5 1.5 0 0 0 3 0z\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default sdCardSolid
